import { Drawer, Button } from "antd";
import Icon from "@ant-design/icons";
import { TrolleyIcon, PriorityIcon } from "../../assets/icons/icons";
import { useTrolleyById } from "../../pages/common/queries";
import "./ConfirmationModal.scss";
import { convertUTCToLocal } from "../../utils/timeUtils";
import { getTrolleyStatus } from "../reusable/styles";

interface TrolleyConfirmationModalProps {
  open: boolean;
  trolleyId: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const TrolleyConfirmationModal = ({
  open,
  trolleyId,
  onConfirm,
  onCancel,
  isLoading = false,
}: TrolleyConfirmationModalProps) => {
  const { data: trolleyData } = useTrolleyById(trolleyId);

  // Check if any tote has High priority
  const hasHighPriorityTote = Boolean(
    trolleyData?.totes?.some(
      (tote) => tote.priority && tote.priority.toLowerCase() === "high"
    ) || trolleyData?.priority
  );

  return (
    <Drawer
      open={open}
      onClose={onCancel}
      className="confirmation-drawer trolley-drawer"
      placement="bottom"
      closable={false}
      mask={true}
      height="auto"
      destroyOnClose
    >
      <div className="confirmation-content">
        <h2 className="confirmation-title">Trolley Loading</h2>
        <p className="confirmation-subtitle">
          You're about to assign this tote to the following trolley:
        </p>

        {trolleyData && (
          <div className="info-card single-card">
            <div className="info-header">
              <div className="info-row">
                <Icon component={TrolleyIcon} className="info-icon" />
                <div>
                  <div className="info-label">Trolley ID</div>
                  <div className="info-value">{trolleyData.id}</div>
                </div>
              </div>
              {hasHighPriorityTote && (
                <div className="priorityTag">
                  <Icon component={PriorityIcon} />
                  <span>Priority</span>
                </div>
              )}
            </div>

            <div className="info-details-grid">
              <div className="info-item">
                <div className="info-label">Status</div>
                <div
                  className="info-value-small"
                  style={{ color: getTrolleyStatus(trolleyData.status) }}
                >
                  {trolleyData.status}
                </div>
              </div>
              <div className="info-item">
                <div className="info-label">Registered Date</div>
                <div className="info-value-small">
                  {trolleyData.registeredDate
                    ? convertUTCToLocal(trolleyData.registeredDate)
                    : "N/A"}
                </div>
              </div>
            </div>

            <div className="info-single-row" style={{ marginTop: "10px" }}>
              <div className="info-label">Last Scanned Location</div>
              <div className="info-value-dark">
                {trolleyData.lastScannedLocation || "N/A"}
              </div>
            </div>
          </div>
        )}

        <div className="modal-actions">
          <Button
            onClick={onCancel}
            className="cancel-button"
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="confirm-button"
            loading={isLoading}
            disabled={isLoading}
          >
            Confirm Load
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default TrolleyConfirmationModal;
